define.alias("shared/helpers/has-item", "preview-grid/helpers/has-item");